function headerHeightAnnouncement() {
    var announcementBar = document.querySelector(".section-announcement-bar");
    var header = document.querySelector(".header-wrapper");
    var subMenu = document.querySelectorAll(".header__submenu");
    var barHeight;
    if(announcementBar) {
      barHeight = announcementBar.offsetHeight;
    }
    var headerHeight;
    if(headerHeight) {
      var headerHeight = header.offsetHeight;
    }
    var windowHeight = window.innerHeight;
    var totalheight = headerHeight;
    var headerSection =  document.getElementById('shopify-section-header');
    if(headerSection) {
      if (!headerSection.classList.contains("shopify-section-header-sticky")) {
        totalheight = barHeight + headerHeight;
      }
    }

    if( subMenu.length ) {
        subMenu.forEach(function (item) {
            item.setAttribute('style',`top:${totalheight}px !important;height:${windowHeight - totalheight}px`);
            // item.style.top = totalheight + `px`;
            // item.style.height = windowHeight - totalheight + "px";
        });
    }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');
    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        if(event.target.closest('#nav-header')){
            headerHeightAnnouncement()
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            if( summary.classList.contains('second-level-menus') || summary.closest('.hamburger') ) {
            document.body.classList.add('open');
            } else {
                document.querySelector('body').classList.toggle('open');
            }
        }
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.addEventListener('DOMContentLoaded', () => {
    headerHeightAnnouncement();
});

window.addEventListener('resize', () => {
    headerHeightAnnouncement();
});

var subMenu = document.querySelectorAll('.second-level-menus');
for (var i = 0; i < subMenu.length; i++) {
    subMenu[i].addEventListener('click', onClickSubMenu);
}

function onClickSubMenu(e) {
    var currentTarget = e.currentTarget;
    var menuParentId = currentTarget.closest('details').getAttribute('id');
    var activeMenus = document.querySelectorAll('.Details-HeaderSubMenu');
    activeMenus.forEach(function (activeMenu) {
     var activeMenuId = activeMenu.getAttribute('id');
        if (menuParentId != activeMenuId) {
            if (activeMenu.hasAttribute('open')) {
                activeMenu.removeAttribute('open');
                activeMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
    }
    });
}
var navHeader = document.getElementById('nav-header');
// document.addEventListener('click', function(event) {
//     var isClickInsideElement = navHeader.contains(event.target);
//     if( !event.target.closest('#nav-header')) {
//         document.body.classList.remove('open');
//         var activeMenus = document.querySelectorAll('.Details-HeaderSubMenu');
//         activeMenus.forEach(function (activeMenu) {
//             if (activeMenu.hasAttribute('open')) {
//                 activeMenu.removeAttribute('open');
//                 activeMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
//             }
//         });
//     }
//     // if (!isClickInsideElement) {
//     //     document.body.classList.remove('open');
//     //     var activeMenus = document.querySelectorAll('.Details-HeaderSubMenu');
//     //     activeMenus.forEach(function (activeMenu) {
//     //         if (activeMenu.hasAttribute('open')) {
//     //             activeMenu.removeAttribute('open');
//     //             activeMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
//     //         }
//     //     });
//     // }
// });


// store submenu

var storeMenu = document.querySelector('.store-menu');
var storeDropdown = document.querySelector('.utility-menu');
if(storeDropdown) {
    storeMenu.addEventListener("click", menuOpen);
    function menuOpen(){
        if( !storeDropdown.classList.contains('show') ){
            storeDropdown.classList.add('show');
        }else{
            storeDropdown.classList.remove('show');
        }
    }
}

// Mega Menu
function megaMenu() {
  let primaryNav = document.getElementById("hasMegaMenu");
  if(primaryNav) {
    const navItems = primaryNav.querySelectorAll(".header__menu-li-js");
    const navItemsNoDrop = primaryNav.querySelectorAll(".header__menu-li-nodrop-js");
    const navWrapper = primaryNav.querySelector(".list-menu--mega");
    const bgBackground = document.querySelector(".hasMegaMenu-overlay");
    let primaryNavHeight = primaryNav.clientHeight;
    let globalDropdownVisibility = primaryNav.querySelectorAll(
      ".dropdown-menu__visibility"
    );
    let dropdownMaxHeight = 0;

    if (navItems) {
      navItems.forEach((navItem) => {
        let dropdownMenu = navItem.querySelector(".dropdown-menu");
        if(dropdownMenu) {
          let dropdownMenuHeight = navItem.querySelector(".dropdown-menu").clientHeight;
          let bgBackgroundHeight = parseInt(dropdownMenuHeight) + parseInt(primaryNavHeight);
          // Function to update the height of the dropdown menu
          function updateDropdownMenuHeight() {
            dropdownMenuHeight = navItem.querySelector(".dropdown-menu").clientHeight;
            bgBackgroundHeight = parseInt(dropdownMenuHeight) + parseInt(primaryNavHeight);
          }
          updateDropdownMenuHeight()

          // Add event listener for window resize based on matchMedia
          let megaMenuDesktopWidth = window.matchMedia("(min-width: 992px)");
          megaMenuDesktopWidth.addEventListener("change", updateDropdownMenuHeight);

          //setting bgBackground height to the max height of the dropdown
          // if (bgBackgroundHeight > dropdownMaxHeight) {
          // }

          let dropdownVisibility = navItem.querySelector(
            ".dropdown-menu__visibility"
          );
          navItem.addEventListener("mouseleave", (e) => {
            setTimeout(() => {
              dropdownVisibility.classList.remove("is-visible");
            }, 100);
          });

          navItem.addEventListener("mouseenter", (e) => {
            dropdownVisibility.classList.add("is-visible");

            //once entered changing the globalDropdown visibility transition delay and speed
            globalDropdownVisibility.forEach((e) => {
              e.style.transitionDelay = "0.17s";
              e.style.transitionDuration = "0s";
            });

            primaryNav.classList.add("activated");
            bgBackground.style.height = bgBackgroundHeight + "px";
            document.body.classList.add("nav-overflow-hidden");
          });
        }
      });
    }

    if (navItemsNoDrop) {
      navItemsNoDrop.forEach((navItemNoDrop) => {
        navItemNoDrop.addEventListener("mouseenter", (e) => {
          primaryNav.classList.remove("activated");
            globalDropdownVisibility.forEach((e) => {
              e.style.transitionDelay = "0s";
              e.style.transitionDuration = "0s";
            });
          setTimeout(() => {
            bgBackground.style.height = "0px";
          }, 170);
          document.body.classList.remove("nav-overflow-hidden");
        });
      });
    }

    navWrapper.addEventListener("mouseleave", () => {
      primaryNav.classList.remove("activated");
      globalDropdownVisibility.forEach((e) => {
        e.style.transitionDelay = "0s";
        setTimeout(() => {
          e.style.transitionDelay = "0.17s";
        }, 100);
      });

      bgBackground.style.height = "0px";
      document.body.classList.remove("nav-overflow-hidden");
    });
  }
}

function multipleDrawerMenuMobile() {
  let primaryNav = document.getElementById("hasMegaMenu");
  if(primaryNav) {
    const navItemsMobile = primaryNav.querySelectorAll(".header__menu-li-mobile-js");
      navItemsMobile.forEach((navItem) => {

        let dropdownMenu = navItem.querySelector(".dropdown-menu");
        let navItemLink = navItem.querySelector(".menu-drawer__menu-item");
        if (dropdownMenu) {
          let backButton = navItem.querySelector(".secondDrawer-back-js");
          let crossButton = navItem.querySelector(".secondDrawer-cross-js");

          backButton.addEventListener("click", () => {
            dropdownMenu.classList.remove("is-visible");
            primaryNav.classList.remove("activated");
          });

          crossButton.addEventListener("click", () => {
            crossButton.closest("#Details-menu-drawer-container").querySelector("summary").click();
            dropdownMenu.classList.remove("is-visible");
            primaryNav.classList.remove("activated");
          });


          navItemLink.addEventListener("click", (e) => {
            e.preventDefault();
            dropdownMenu.classList.add("is-visible");
            primaryNav.classList.add("activated");
          });
        }
      });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  megaMenu();
  multipleDrawerMenuMobile();
});
